import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IKeyValuePair } from 'models';


@Injectable({
    providedIn: 'root'
})
export class AppSettingService {
    constructor(private http: HttpClient) {}

    public get(): Observable<IKeyValuePair[]> {
        return this.http.get<IKeyValuePair[]>('api/settings/get');
    }
}
